import type { UUIDString } from '@aigc/types';
import { useQuery } from '@tanstack/react-query';
import { Alert, Button, Table } from 'antd';
import { TaskResultItem } from '../../task/components/task-result-item';
import type { TaskType, VideoTaskDto } from '../../task/model';
import {
  getAdminVideoGenerationTasksQueryOptions,
  getVideoGenerationTasksQueryOptions,
} from '../api';
import type { VideoGenerationTaskListInputDto } from '../model';

export const VideoGenerationTaskTable = (props: {
  scriptId?: UUIDString;
  taskType: TaskType[];
  admin?: boolean;
  onEditVideo?: (filename: string) => void;
  onRowClick?: (row: VideoTaskDto) => void;
}) => {
  const params: VideoGenerationTaskListInputDto = {
    script_id: props.scriptId,
    task_type: props.taskType,
  };
  const pagination = { page: 1, size: 100 };
  const { data, dataUpdatedAt, isFetching, isError, refetch } = useQuery({
    ...(props.admin
      ? getAdminVideoGenerationTasksQueryOptions(pagination, params)
      : getVideoGenerationTasksQueryOptions(pagination, params)),
  });

  if (isError) {
    return (
      <Alert
        className="mt-2"
        type="error"
        title="视频生成任务加载失败"
        description="请检查网络连接后重试"
        action={
          <Button size="small" onClick={() => refetch()}>
            重试
          </Button>
        }
      ></Alert>
    );
  }

  return (
    <Table
      size="small"
      tableLayout="fixed"
      classNames={{ root: 'mt-2' }}
      showHeader={false}
      loading={isFetching}
      rowKey={(row) => row.id}
      dataSource={data?.items as VideoTaskDto[]}
      columns={[
        {
          className: 'space-y-2',
          render: (_, row) => {
            return (
              <TaskResultItem
                task={row}
                dataUpdatedAt={dataUpdatedAt}
                onEditVideo={props.onEditVideo}
                onShowDetails={() => {
                  props.onRowClick?.(row);
                }}
              ></TaskResultItem>
            );
          },
        },
      ]}
      pagination={{
        hideOnSinglePage: true,
      }}
    ></Table>
  );
};
